import React from 'react'
import ShareSvg from 'images/modules/Manage/i-share-gray.svg?raw'

export { default as ShareUrl } from 'images/modules/Manage/i-share-gray.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: ShareSvg}} />
)
